import { useEffect, useRef } from "react";
import { gsap } from "gsap";

const useFadeInOnLoad = (delay = 0) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      gsap.fromTo(
        ref.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          delay: delay,
          ease: "power2.out",
        }
      );
    }
  }, [delay]);

  return ref;
};

export default useFadeInOnLoad;
